import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .reddit_info_wrapper {
    display: flex;
    flex-direction: row;
  }
  .content.column:first-child {
    width: 60%;
    padding: 30px 60px 0 0;
  }
  .content.column:nth-child(2) {
    width: 40%;
    align-items: center;
  }
  .content.column.linked_to_reddit {
    width: 100% !important;
    align-items: center;
    border-top: 1px solid var(--tab-bar-border);
    margin: 15px 0 0 0;
  }
  .reddit_content .reddit_url {
    font-size: 1rem;
    font-weight: 600;
    padding: 0 0 15px 0;
  }
  .reddit_content .reddit_description {
    font-size: 0.8rem;
    line-height: 130%;
  }
  .reddit_content .reddit_stats-main {
    border-top: 1px solid var(--tab-bar-border);
    border-bottom: 1px solid var(--tab-bar-border);
    padding: 20px 0;
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .reddit_content .reddit_stats-main .title {
    font-weight: 600;
    font-size: 0.9rem;
    padding: 0 0 10px 0;
  }
  .reddit_content .reddit_stats-main .value {
    font-size: 0.8rem;
    position: relative;
    padding: 0 0 0 25px;
  }
  .reddit_content .reddit_stats-main .reddit_stat-karma .value:before {
    background: url(${icons.reddit_karma_icon}) center center / 18px auto
      no-repeat;
    width: 18px;
    height: 18px;
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .reddit_content .reddit_stats-main .reddit_stat-cakeday .value:before {
    background: url(${icons.reddit_cakeday_icon}) center center / 18px auto
      no-repeat;
    width: 18px;
    height: 18px;
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 0 14px 30px;
  }
  .content.column .subtitle {
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
  }
  .content.column .subtitle#reddit-subtitle {
    margin: 0 0 14px 0;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content.reddit_stats-global {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content.stats {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    background: hsla(0, 0%, 100%, 0.05);
    margin: 0 -30px 0 0;
    padding: 15px 25px 15px 15px;
    border-radius: 10px 0 0 10px;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content.stats label {
    padding: 0;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.8rem;
    justify-content: flex-end;
    max-width: 300px;
  }
  .grid-content.stats label.title {
    text-align: left;
    text-transform: none;
    font-size: 0.8rem;
    justify-content: flex-start;
    max-width: 300px;
    padding: 0 0 5px 0;
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.stats label.value {
    margin: 0;
    padding: 0 0 15px 0;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.stats label.value:last-child {
    padding: 0;
  }
`
const developerCSS = css`
  .reddit_url a {
    text-decoration: none;
  }
`

export const UserRedditOverviewCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
